import { render, staticRenderFns } from "./IotAlertListForDetail.vue?vue&type=template&id=68a5ff3c&scoped=true&"
import script from "./IotAlertListForDetail.vue?vue&type=script&lang=js&"
export * from "./IotAlertListForDetail.vue?vue&type=script&lang=js&"
import style0 from "./IotAlertListForDetail.vue?vue&type=style&index=0&id=68a5ff3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a5ff3c",
  null
  
)

export default component.exports